import _ from 'underscore';
import { AssetEventRecordType, AssetType, POST_ASSET_EVENT_NAME } from './constants';
import { prefillAssetsAppliedLog } from './event-logs';


const getCopilotAppliedRecommendations = ({ copilotTracking, assetGroup }) => {
  const assetType = [];
  const suggestionIds = [];
  const appliedImageAssetIds = [];

  const { trackingData } = copilotTracking || {};
  const { textSuggestions, imageSuggestions, finalUrlSuggestions } = trackingData || {};

  const {
    Descriptions, Headlines, LongHeadlines, Images, FinalUrls,
  } = assetGroup || {};

  // Get applied copilot text assets by text match
  const currentTextAssets = _.flatten([_.values(Descriptions), _.values(Headlines), _.values(LongHeadlines)]);

  const copilotTextRecommendations = _.filter(textSuggestions, asset => _.contains(currentTextAssets, asset.Text));
  const copilotTextRecommendationIds = _.uniq(_.pluck(copilotTextRecommendations, 'RecommendationId'));
  _.each(copilotTextRecommendationIds, (v) => {
    suggestionIds.push(v);
    assetType.push(AssetType.TEXT);
  });

  // Log applied copilot headline ofr DKI
  const copilotHeadlineRecommendations = _.filter(textSuggestions, asset => _.contains(Headlines, asset.Text));
  const appliedHeadlines = _.pluck(copilotHeadlineRecommendations, 'Text');

  // Get applied copilot image recommendations by imageId match
  const { ImageList } = Images;
  const currentImageAssets = _.uniq(_.map(_.flatten(ImageList), image => (image.id ? image.id.toString() : null)));
  const copilotImageRecommendations = _.uniq(_.filter(imageSuggestions, asset => _.contains(currentImageAssets, asset.imageId)));

  _.each(copilotImageRecommendations, (v) => {
    suggestionIds.push(v.suggestionId);
    assetType.push(AssetType.IMAGE);
    appliedImageAssetIds.push(v.imageId);
  });

  const appliedFinalUrlRecommendations = _.chain(finalUrlSuggestions)
    .uniq()
    .intersection(FinalUrls)
    .value();

  return {
    suggestionIds,
    assetType,
    appliedImageAssetIds,
    appliedFinalUrlRecommendations,
    appliedHeadlines,
  };
};

export const logCopilotRecommendations = ({
  recommendationContext, assetGroup, campaignId = null, isEditing,
}) => {
  const { postAssetEventLog, copilotTracking } = recommendationContext;

  if (_.isFunction(postAssetEventLog) && copilotTracking) {
    const {
      suggestionIds, assetType, appliedImageAssetIds, appliedFinalUrlRecommendations, appliedHeadlines,
    } = getCopilotAppliedRecommendations({ copilotTracking, assetGroup });

    const eventValue = {
      AssetGroupId: assetGroup.Id,
      RecordType: AssetEventRecordType.APPLIED,
      SuggestionIds: suggestionIds,
      AssetType: assetType,
      ...(appliedImageAssetIds.length > 0 && { AppliedImageAssetIds: appliedImageAssetIds }),
      ...(appliedFinalUrlRecommendations.length > 0 && { FinalUrls: appliedFinalUrlRecommendations }),
      ...(appliedHeadlines.length > 0 && { AppliedHeadlines: appliedHeadlines }),
    };

    if (campaignId) {
      eventValue.CampaignId = campaignId;
    }

    postAssetEventLog({
      EventName: POST_ASSET_EVENT_NAME,
      EventValue: eventValue,
    });

    if (!isEditing) {
      const initialSuggestionsData = copilotTracking.getInitialSuggestionsData();

      if (!_.isEmpty(initialSuggestionsData)) {
        postAssetEventLog(prefillAssetsAppliedLog(campaignId, initialSuggestionsData));
      }
    }
  }
};
